if (process.env.NODE_ENV === "production") {
  console.warn = () => {};
  console.error = () => {};
}
